module.exports = __webpack_public_path__ + "static/media/igtr.717925d9.png";